module.exports = __webpack_public_path__ + "static/img/major_pictgrid13_800x743.156c21a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/major_pictgrid13_800x743.jpg
// module id = 3go3
// module chunks = 0